export const FILTER_PARAM = 'filter';
export const VIEW_PARAM = 'view';

/** Set to false to hide the view tab bar (List, Gap Analysis, etc.) in the products hub. */
export const VIEW_TABS_VISIBLE = false;

export const VIEWS = [
    { value: 'list', label: 'List' },
    { value: 'gap-analysis', label: 'Gap Analysis' },
    { value: 'ai-summaries', label: 'AI Summaries' },
    { value: 'key-questions', label: 'Key Questions' },
    { value: 'graph', label: 'Graph' },
];

// O(1) label lookup — avoids scanning VIEWS on every render
export const VIEWS_MAP = new Map(VIEWS.map((v) => [v.value, v.label]));
